import React from 'react'

import PrivacyPolicy from '../components/privacyPolicy/PrivacyPolicy'

function Legal() {
	return <PrivacyPolicy />
}

export default Legal
